import React from "react";
import PropTypes from "prop-types";
import { Table } from "components";
import { UNDERWRITING_DISTRIBUTOR_COLS } from "constants/table-columns";
import { List } from "immutable";

class DistributorsDataTable extends React.Component {
    render() {
        return (
            <Table
                title={"Distributors List"}
                columns={UNDERWRITING_DISTRIBUTOR_COLS}
                checkedCols={[]}
                showFilters={true}
                showColumnSelector={true}
                onFilter={this.props.onFilter}
                data={
                    this.props.data ?
                        this.props.data
                            .sort((a, b) => (a.uapr_id > b.uapr_id) ? -1 : 1)
                            .map(_ => {
                                let row = _.set("distributor_name", (
                                    <a onClick={() => {
                                        this.props.router(
                                            `/app/underwriting/jobs/${_.uapr_id}`
                                        );
                                    }}>{_.distributor_name}</a>
                                ));
                                return row;
                            })
                        : new List([])
                }
                keyFilter={this.props.keyFilter}
                showBulkDropdown={true}
                // bulkActionDropdown={this.BulkDropdown}
                showCsvBtn={true}
                showAssetsBtn={false}
                showTitle={true}
                fixedColsLeft={[]}
                // loading={this.props.loading}
                size={"middle"}
                editable={false}
                showFooter={true}
                pagination={{
                    current: +(this.props.currentPage),
                    showSizeChanger: true,
                    defaultPageSize: 20,
                    pageSizeOptions: ["20", "30", "50", "100", "500"],
                    position: "bottom",
                    total: this.props.count,
                    onChange: (page, pageSize) =>
                        this.props.onPageChange(page, pageSize),
                    onShowSizeChange: this.props.onPageChange
                }}
            />
        );
    }
}

DistributorsDataTable.propTypes = {
    keyFilter: PropTypes.string,
    count: PropTypes.number,
    data: PropTypes.object,
    onPageChange: PropTypes.func,
    currentPage: PropTypes.string,
    router: PropTypes.func,
    onFilter: PropTypes.func,
    loading: PropTypes.bool
};

export default DistributorsDataTable;
